/** Align DGS10 and DGS2 macro bars and compute 10y − 2y spread (percentage points). */

/** Calendar-month mean of daily observations; `time` = last trading day in that month. */
export function monthlyMeanBars(bars) {
  const buckets = new Map();
  for (const bar of bars || []) {
    const month = bar.time.slice(0, 7);
    const v = Number(bar.value);
    if (Number.isNaN(v)) continue;
    let bucket = buckets.get(month);
    if (!bucket) {
      bucket = { sum: 0, n: 0, lastTime: bar.time };
      buckets.set(month, bucket);
    }
    bucket.sum += v;
    bucket.n += 1;
    if (bar.time >= bucket.lastTime) bucket.lastTime = bar.time;
  }
  return [...buckets.keys()]
    .sort()
    .map((month) => {
      const b = buckets.get(month);
      return { time: b.lastTime, value: b.sum / b.n };
    });
}

export function macroDateYearsAgo(years) {
  const to = new Date();
  const from = new Date(to);
  from.setFullYear(from.getFullYear() - years);
  return {
    from: from.toISOString().slice(0, 10),
    to: to.toISOString().slice(0, 10),
  };
}

export function computeYieldCurveSpread(bars10y, bars2y) {
  const by2y = new Map((bars2y || []).map((b) => [b.time, Number(b.value)]));
  const spread = [];
  for (const bar of bars10y || []) {
    const v10 = Number(bar.value);
    const v2 = by2y.get(bar.time);
    if (v2 == null || Number.isNaN(v10) || Number.isNaN(v2)) continue;
    spread.push({ time: bar.time, value: v10 - v2 });
  }
  return spread;
}

export function zeroLineFromSpread(spreadBars) {
  return (spreadBars || []).map((b) => ({ time: b.time, value: 0 }));
}

export function formatSlopeRange(spreadBars) {
  if (!spreadBars?.length) return '';
  const first = spreadBars[0].time;
  const last = spreadBars[spreadBars.length - 1].time;
  const fmt = (iso) => {
    const [y, m] = iso.split('-');
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${months[Number(m) - 1]} ${y}`;
  };
  return `${fmt(first)} – ${fmt(last)}`;
}
